import { useQuery } from '@apollo/client'
import { GET_CHECKOUT_SESSION } from '@graphql/queries/getCheckoutSession.query'
import { getDomainExtension } from '@utils/getDomainExtension'
import { getLocaleForAdyen } from '@utils/getLocaleForAdyen.utils'
import { BookingCreateAdyenSessionQuery, BookingCreateAdyenSessionQueryVariables } from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedQuery } from './useAuth'

const useUserCheckoutSession = (orderId: number, email: string, lng: string) => {
    return useAuthenticatedQuery<BookingCreateAdyenSessionQuery, BookingCreateAdyenSessionQueryVariables>({
        query: GET_CHECKOUT_SESSION,
        variables: {
            id: orderId,
            shopper_email: email,
            shopper_locale: getLocaleForAdyen(lng),
            top_level_domain: getDomainExtension()
        },
        fetchPolicy: 'network-only'
    })
}

const useCheckoutSession = (orderId: number, email: string, lng: string) => {
    return useQuery<BookingCreateAdyenSessionQuery, BookingCreateAdyenSessionQueryVariables>(GET_CHECKOUT_SESSION, {
        variables: {
            id: orderId,
            shopper_email: email,
            shopper_locale: getLocaleForAdyen(lng),
            top_level_domain: getDomainExtension()
        },
        fetchPolicy: 'network-only'
    })
}

export { useCheckoutSession, useUserCheckoutSession }
